<template>
  <v-dialog v-model="modal" max-width="500">
    <v-card>
      <v-card-title> Annuler les modifications ? </v-card-title>
      <v-card-text>
        <slot
          >Vous avez des modifications en cours, voulez-vous les annuler et
          poursuivre votre navigation ?</slot
        >
      </v-card-text>
      <v-card-actions>
        <v-btn data-testid="valider-confirmer-navigation" @click="confirme" color="primary">Oui</v-btn>
        <v-btn data-testid="annuler-confirmer-navigation" ref="non" text @click="ferme">Non</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import makeDialog from "@/mixins/makeDialog";

export default {
  mixins: [makeDialog]
};
</script>
